import React from 'react';
import Statement from './Statement';
import { useTranslation } from 'react-i18next';

const CellFormatingElseStatement = (props) => {

    const { t } = useTranslation([
        "attribute/cell_formatting",
    ]);

    const { updateStatement, removeStatement, statement } = props;
    const { color, colorOption } = statement;

    const handleColorChange = (value) => {
        const updatedStatement = { ...statement, color: value };
        updateStatement(updatedStatement);
    }

    const handleColorOptionChange = (value) => {
        const updatedStatement = { ...statement, colorOption: value };
        updateStatement(updatedStatement);
    }

    const handleRemoveStatement = () => {
        removeStatement(statement.id);
    }

    return <Statement
        label={t("else_statement")}
        color={color}
        onColorChange={handleColorChange}
        colorOption={colorOption}
        onColorOptionChange={handleColorOptionChange}
        removeTitle={t("remove_else_condition")}
        onRemove={handleRemoveStatement}
    />
};

export default CellFormatingElseStatement;